import {useNavigate} from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import React, {useState} from 'react';
import { SimpleSearch } from '../../../../../reduxToolkit/Search/SearchApi';
import {SEARCH_MODEL} from '../../../../../components/table/Model/TableModel';
import {EMPTY_VALUES, getValueByKey} from '../../../../../Apis/functions';
import CustomTh from "../../../../../components/table/CustomTh";
import CustomTd from "../../../../../components/table/CustomTd";
import {MODEL_MEASUREMENT_UNIT} from "../Model/Models";
import DropDownMenuProfile from "../../../../../components/DropDown/DropDownMenuProfile";
import {permissionObj} from "../../../../../Helpers/permission";
import DropDownMenuItem from "../../../../../components/DropDown/DropDownMenuItem";
import {DeleteIconsOptions, UpdateIconsOptions} from "../../../../../components/buttons/IconButtons";
import routes from "../../../../../Routes/routes";
import TableFunction from "../../../../../components/table/TableFunction";
import {getViewTypeByName} from "../../../../../enums/ViewType";

/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack
 * @Email : kpozos@ibl.mx
 *
 */
const IngredientsTableApp = ({
    view,
    setBodyForExport,
    modified,
    setModified,
    selectedList,
    setSelectedList,
    setIsAllChecked,
    handleDelete,
    option
}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const [searchElement, setSearchElement] = useState('');
    const [searchResults, setSearchResults] = useState('');
    const [search, setSearch] = useState(false);
    const [simpleSearch, setSimpleSearch] = useState(false);
    const tableId = "tbl_it_ingredient";
    const searchId = "txt_it_search_ingredient";
    const viewType = getViewTypeByName(view);
    const deletePermission = DEV || permission?.includes(permissionObj?.WEB_INGREDIENT_DELETE);

    const getThead = () => {
        return [
            <CustomTh tableId={tableId} classes='first_head'>{t('ingredient')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('item_code')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('unit_of_measure')}</CustomTh>
        ];
    };
    const getTbody = () => {
        if (!searchResults || searchResults?.content?.length === 0)
            return {
                body: [],
                data: [],
            };

        let body = searchResults?.content.map(item => {
            return (
                <>
                    <CustomTd tableId={tableId} classes={'first-column'}>{item?.name}</CustomTd>
                    <CustomTd tableId={tableId}>{item?.code }</CustomTd>
                    <CustomTd tableId={tableId}>{item?.measurementUnitName ? t(getValueByKey(item.measurementUnitName, 'trans', MODEL_MEASUREMENT_UNIT)) :  EMPTY_VALUES.DEFAULT}</CustomTd>
                </>
            );
        });

        return {
            body: body,
            data: searchResults?.content,
        };
    };


    const getActionsButtons = (item, index) => {
        return <>
            <DropDownMenuProfile
                openMenu={openMenu}
                handleMenuToggle={handleMenuToggle}
                menuId={`menu-${item.id}`}
            >
                { (DEV || permission?.includes(permissionObj?.WEB_INGREDIENT_UPDATE)) &&
                <DropDownMenuItem
                    index={index}
                    handleClose={handleClose}
                    name={t("update")}
                    icon={<UpdateIconsOptions/>}
                    click={() => {
                        navigate(`${routes.foodieIngredient.addEdit}${item.id}`);
                    }}
                />
                }


                { (DEV || permission?.includes(permissionObj?.WEB_INGREDIENT_DELETE)) &&
                <DropDownMenuItem
                    index={index}
                    handleClose={handleClose}
                    name={t("delete")}
                    fontColor='font-color-error-600'
                    iconColor={"icon-color-error-code-600"}
                    icon={<DeleteIconsOptions/>}
                    click={() => {
                        handleDelete(item);
                    }}
                />
                }
            </DropDownMenuProfile>
        </>;
    }

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page) => {
        const body = SEARCH_MODEL.setObject({
            page: page,
            size: rowsPerPage,
            model: option,
            key: searchElement,
            viewType: viewType,
        });
        setBodyForExport(body);
        dispatch(SimpleSearch({ body })).then(({ payload: { data: { data, success } } }) => {
                if (success === true) {
                    setSearchResults(data);
                }
            }
        );
    }

    /**
     * Pagination for list view, and other
     */
    const {
        t,
        thead,
        tbody,
        handleCheckboxChange,
        handleDeleteAll,
        openMenu,
        handleMenuToggle,
        handleClose,
        pagination,
        rowsPerPage,
    } = TableFunction({
        selectedList, setSelectedList,
        data:searchResults,
        labelRowsPerPage: 'ingredient_per_page',
        getTbody,
        getThead,
        setIsAllChecked,
        fixedPagination: false, // Disable fixed pagination
        hasContainer: true, // Enable container for the table
        searchElement, //New
        getData,//New
        modified,//New
        setModified,//New
    });

    return {
        t,
        DEV,
        navigate,
        permission,
        searchId,
        tableId,
        thead,
        tbody,
        rowsPerPage,
        setSearchResults,
        searchElement,
        setSearchElement,
        search,
        setSearch,
        setSimpleSearch,
        handleDeleteAll,
        handleCheckboxChange,
        getActionsButtons,
        pagination,
        deletePermission
    }

}

export default IngredientsTableApp;
